import { GenericDropdownOption } from 'App.types';
import { creatorbase } from '@round/api';

export const financeStatusOptions: GenericDropdownOption<creatorbase.FinanceStatus>[] = [
    { value: 'pending', label: 'Pending' },
    { value: 'cancelled', label: 'Cancelled' },
    { value: 'action_needed', label: 'Action Needed' },
    { value: 'confirmed_to_bill', label: 'Confirmed to Bill' },
    { value: 'invoiced', label: 'Invoiced' },
];
